/***
 *
 *   FORM ERROR STYLES
 *   The reference renders validation errors as plain `text-error` copy under
 *   the field, not as a filled red block.
 *
 **********/

const Style = {
    base: 'relative block text-xs text-error',
};

export default Style;
